"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _components = require("../../components");

var _searchSuggestion = _interopRequireDefault(require("../../legacy/search-suggestion"));

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchBarContainer = (0, _styledComponents["default"])(_components.Section).withConfig({
  displayName: "search__SearchBarContainer",
  componentId: "sc-10owv4o-0"
})(["border-bottom:1px solid ", ";"], function (props) {
  return (0, _styles.colors)("grey", props);
});
var propTypes = {
  // Currently active filters list
  activeFilters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // Function to cancel search
  cancelSearch: _propTypes.func,
  // Container root element class name
  className: _propTypes.string,
  // Function to fetch more search results
  fetchMoreResults: _propTypes.func,
  // List of all search filters
  filters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // Flag to show if search is loading
  isLoading: _propTypes.bool,
  // Function to be called when search filter change
  onFilterChange: _propTypes.func,

  /** Search input onFocus function */
  onFocus: _propTypes.func,

  /** Search input onChange function */
  onQueryChange: _propTypes.func,
  // Searchbar placeholder
  placeholder: _propTypes.string,

  /** Search Results */
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    className: _propTypes.string,
    description: _propTypes.string,
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string,
    url: _propTypes.string
  })),
  // Number of search results found
  resultsCount: _propTypes.number,

  /** Input onChange function */
  showLoadMoreResults: _propTypes.bool,

  /**
   * Current suggested terms array. Suggestions can optionally take any <Box />
   * props including `tag` to change element type.
   */
  suggestions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Suggestion object id, used as element key */
    children: _propTypes.node,

    /** Suggestion content, usually term title string */
    id: _propTypes.string.isRequired
  })),

  /** Search input query value */
  value: _propTypes.string
};
var defaultProps = {
  suggestions: []
};
/**
 * High level search component that accepts an array of objects with suggested
 * terms component props. Composes SearchBar and SearchSuggestion. Include `tag`
 * prop in suggestion objects to change suggestion root component type. Useful
 * for using "a" tags or react-router Link components.
 */

var Search = function Search(_ref) {
  var activeFilters = _ref.activeFilters,
      className = _ref.className,
      value = _ref.value,
      onQueryChange = _ref.onQueryChange,
      onFocus = _ref.onFocus,
      onFilterChange = _ref.onFilterChange,
      _ref$suggestions = _ref.suggestions,
      suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions,
      filters = _ref.filters,
      placeholder = _ref.placeholder,
      results = _ref.results,
      resultsCount = _ref.resultsCount,
      isLoading = _ref.isLoading,
      showLoadMoreResults = _ref.showLoadMoreResults,
      fetchMoreResults = _ref.fetchMoreResults,
      cancelSearch = _ref.cancelSearch;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    className: className,
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(SearchBarContainer, null, /*#__PURE__*/_react["default"].createElement(_components.SearchBar, {
    onChange: onQueryChange,
    onFocus: onFocus,
    placeholder: placeholder,
    suggestions: suggestions.length ? suggestions.map(function (suggestion) {
      return /*#__PURE__*/_react["default"].createElement(_searchSuggestion["default"], _extends({
        key: suggestion.id
      }, suggestion));
    }) : null,
    value: value
  })), value ? /*#__PURE__*/_react["default"].createElement(_components.SearchBody, {
    activeFilters: activeFilters,
    cancelSearch: cancelSearch,
    fetchMoreResults: fetchMoreResults,
    filters: filters,
    isLoading: isLoading,
    onChange: onFilterChange,
    results: results,
    resultsCount: resultsCount,
    showLoadMoreResults: showLoadMoreResults
  }) : null);
};

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;
Search.displayName = "Modules.Search";
var _default = Search;
exports["default"] = _default;